import rest from 'rest';
import mime from 'rest/interceptor/mime';
import errorCode from 'rest/interceptor/errorCode';
import pathPrefix from 'rest/interceptor/pathPrefix';
import params from 'rest/interceptor/params';
import redirectOn403 from './interceptors/RedirectOn403';
import normalizeErrors from './interceptors/NormalizeErrors';
import translateErrorMessage from './interceptors/TranslateErrorMessage';
import addAuthHeaders from './interceptors/AddAuthHeaders';
import apiHeaders from './interceptors/AddApiHeaders';
import jsonContentTypeHeaders from './interceptors/JsonContentTypeHeader';
import setRefreshedTokens from './interceptors/SetRefreshedTokens';
export default rest
    .wrap(pathPrefix, { prefix: API_HOST })
    .wrap(params)
    .wrap(addAuthHeaders)
    .wrap(apiHeaders)
    .wrap(jsonContentTypeHeaders)
    .wrap(redirectOn403)
    .wrap(mime)
    .wrap(normalizeErrors)
    .wrap(errorCode)
    .wrap(setRefreshedTokens)
    .wrap(translateErrorMessage);
